import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Overlaytext.css";

const Overlaytext = ({ 
  title,
  subtitle,
  backgroundImage 
}) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
  }, []);

  return (
    <div 
      className="overlay-text-container"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="overlay-black"></div>
      <div className="overlay-content">
        <h1 
          className="overlay-title"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          {title}
        </h1>
        <p 
          className="overlay-subtitle"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          {subtitle}
        </p>
      </div>
    </div>
  );
};

export default Overlaytext;